import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

// v2 team management
export function fetchTeamData() {
  return axios.get(apiUrl.teamV2.GET.DETAIL);
}

export function updateTeamSettings(params) {
  return axios.patch(apiUrl.teamV2.PATCH, params);
}

export function inviteTeamMember(email) {
  return axios.post(apiUrl.teamMemberV2.POST, { email });
}

export function updateTeamMemberRole(memberId, teamRole) {
  return axios.patch(`${apiUrl.teamMemberV2.PATCH}${memberId}/`, { team_role: teamRole });
}

export function deactivateTeamMember(memberId) {
  return axios.patch(`${apiUrl.teamMemberV2.PATCH}${memberId}/`, { is_active: false });
}

// v1 team (deprecated, kept for backwards compatibility)
export function fetchTeamMembers() {
  return axios.get(apiUrl.teamMembers.GET.LIST);
}

export function fetchTeamRoles() {
  return axios.get(apiUrl.teamRoles.GET.LIST);
}

export function updateTeamMember(params) {
  return axios.patch(apiUrl.teamMember.PATCH, params);
}

export function inviteNewTeamMember(params) {
  return axios.put(apiUrl.teamMember.PUT, params);
}

export function updateTeam(params) {
  return axios.patch(apiUrl.team.PATCH, params);
}

export function fetchTeam() {
  return axios.get(apiUrl.team.GET.LIST);
}
